import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

export const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('MIN_LENGTH_6');
      return;
    }
    if (password !== confirm) {
      toast.error('PASSPHRASE_MISMATCH');
      return;
    }
    setBusy(true);
    try {
      await api.post('/auth/password-reset/confirm', { token, new_password: password });
      toast.success('PASSPHRASE_RESET');
      nav('/login');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Reset failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 px-6">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#38BDF8] mb-3">
        // NEW_PASSPHRASE
      </div>
      <h1 className="text-3xl font-bold uppercase tracking-tighter mb-8">
        Set Passphrase<span className="caelix-caret"></span>
      </h1>
      {!token ? (
        <div className="c-card">
          <div className="text-lg text-yellow-400">MISSING_TOKEN</div>
          <p className="text-xs text-gray-500 mt-2">
            &gt; This link is malformed. Request a new reset from{' '}
            <Link to="/forgot-password" className="text-[#38BDF8] hover:underline">/forgot-password</Link>.
          </p>
        </div>
      ) : (
        <form data-testid={AUTH.resetForm} onSubmit={submit} className="c-card space-y-4">
          <div>
            <label className="c-label" htmlFor="reset-password">New Passphrase (6+ chars)</label>
            <input
              id="reset-password"
              data-testid={AUTH.resetPassword}
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="c-input"
            />
          </div>
          <div>
            <label className="c-label" htmlFor="reset-confirm">Confirm Passphrase</label>
            <input
              id="reset-confirm"
              data-testid={AUTH.resetConfirm}
              type="password"
              required
              minLength={6}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••"
              className="c-input"
            />
          </div>
          <button
            data-testid={AUTH.resetSubmit}
            type="submit"
            disabled={busy}
            className="c-btn-primary w-full"
          >
            {busy ? 'RESETTING…' : 'RESET_PASSPHRASE'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ResetPasswordPage;
